export default __webpack_public_path__ + "static/pinterest-936ebbb890ab22e706ab1e32917b3ffa.svg";